<template>
    <!-- модалка планировки -->
    <modal name="sales_land_flat_card_crm_modal" @opened="FlatCardModalOpened" @closed="FlatCardModalClosed" :transition="transitionName" :width="modalWidth" :height="modalHeight" :scrollable="mobileView" id="sales_land_flat_card_crm_modal">
        <div class="modal-content land-flat-modal-content" v-if="modalData != null">
            <button class="btn-close-flat-card--modal" @click="closeFlatModal()"><svg-icon icon-class="close" className="icon-close"/></button>
            <h3 v-if="mobileView" class="mobile-modal-title"><strong>{{modalData.rooms}}-</strong>{{flatsPage.flats_cards_info.flat_modal_title}}</h3>
            <div class="col-left" :class="{active: resizeCardImg}">
                <div class="btn-resize" :class="{active: resizeCardImg}" @click="resizeModalCardImg">
                    <svg-icon icon-class="inresize" className="icon-inresize"/>
                    <svg-icon icon-class="unresize" className="icon-unresize"/>
                </div>
                <div class="flat-card-big-img" v-if="modalData != null && modalData.id != null">
                    <div class="img-in" v-if="modalData.images.length > 0">
                        <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id" v-for="(pic, index) in modalData.images.filter(item => item.typeCode === '1')" :key="index+1">
                    </div>
                </div>
                <div class="flat-card-info-images" v-if="modalData != null && modalData.id != null">
                    <!-- поменять тип код на 3 -->
                    <div class="col col-part" v-for="(pic, index) in modalData.images.filter(item => item.typeCode === '3')" :key="index+2"> 
                        <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id">
                    </div>
                    <div class="col col-plan" v-for="(pic, index) in modalData.images.filter(item => item.typeCode === '2')" :key="index+3"> 
                        <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id">
                    </div>
                    <div class="col col-rose" v-for="(pic, index) in modalData.images.filter(item => item.typeCode === '4')" :key="index+4"> 
                        <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id">
                    </div>
                </div>
            </div>
            <div class="col-right" v-if="modalData != null">
                <div class="flat-card-top-info">
                    <h3 v-if="!mobileView"><strong>{{modalData.rooms}}-</strong>{{flatsPage.flats_cards_info.flat_modal_title}}</h3>
                    <!-- №{{modalData.number}} -->
                    <div class="item-info">
                        <ul>
                            <!-- <li>
                                <div class="left">
                                    Комнат
                                </div>
                                <div class="right">
                                    {{modalData.rooms}}
                                </div>
                            </li> -->
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_size}}
                                </div>
                                <div class="right">
                                    {{modalData.area}} <span>м²</span>
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_floor}}
                                </div>
                                <div class="right">
                                    {{modalData.floor}}
                                </div>
                            </li>
                            <li class="price" v-if="saleItem.project_stie_shablon_price_flats_init == 'true' && modalData.showPricesOnSaleSite == true">
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_price}} м²
                                </div>
                                <div class="right">
                                    <span>от</span> {{getNumber(modalData.meterPrice)}} <span>тг.</span>
                                </div>
                            </li>
                            <li class="price" v-if="saleItem.project_stie_shablon_price_flats_init == 'true' && modalData.showPricesOnSaleSite == true">
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_full_price}}
                                </div>
                                <div class="right">
                                    <span>от</span> {{getFullPrice(modalData.meterPrice, modalData.area)}} <span>тг.</span>
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    {{flatsPage.flats_cards_info.flat_flat_number}}
                                </div>
                                <div class="right">
                                    {{modalData.number}}
                                </div>
                            </li>
                            <li>
                                <div class="left">
                                    <span v-if="modalData.complexCode != 'SOH'">{{flatsPage.flats_cards_info.flat_bloom}}</span>
                                    <span v-else>{{flatsPage.flats_cards_info.flat_kvartal}}</span>
                                </div>
                                <div class="right" v-if="modalData.complexCode != 'SOH'">
                                    {{getNumbersOfString(modalData.blockName)}}
                                </div>
                                <div class="right" v-if="modalData.complexCode == 'SOH'">
                                    {{getNumbersOfBlockSoho(modalData.blockName)}}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="flat-card-btns-container">
                    <div class="flat-btn-print">
                        {{getIdPDF(modalData.images)}}
                        <a :href="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pdf" download target="_blank" class="btn-print" v-if="pdf != null">
                            <svg-icon icon-class="print" className="icon-print"/>
                            <p>{{flats.land_flats_cards_info.flat_btn_print_name}}</p>
                        </a>
                    </div>
                    <div class="flat-btn-mail">
                        <a href="#" class="btn-mail" @click.prevent="InputMailInit"  v-if="!formActive && pdf != null"> 
                            <svg-icon icon-class="mail" className="icon-mail"/>
                            <p>{{flats.land_flats_cards_info.flat_btn_mail_name}}</p>
                        </a>
                        <transition name="fade">
                            <formMail v-if="formActive"
                                    :options="[{pdf: 'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pdf, name: modalData.rooms + ' ком. квартира ' +  modalData.area + 'м²' + ' в ' + CapitalizeID(project) + '.pdf'}]"
                            ></formMail>
                        </transition>
                    </div>
                    <div class="by-btns-group" v-if="saleFilterParams.project_stie_flats_filter_init == 'true'">
                        <div v-if="modalData.complexCode == 'ALF' || modalData.complexCode == 'EST' || modalData.complexCode == 'JAZ' || modalData.complexCode == 'ОRI' || modalData.complexCode == 'PRV' || modalData.complexCode == 'SOH'">
                            <a 
                                :href="'https://lk01.bazis.kz/?apartment_id=' + modalData.id + '&method=book'" class="bron" target="_blank" 
                                v-if="modalData.isApartmentReserved"
                                >{{flatsPage.flats_cards_info.flat_btn_book_name}}
                            </a>
                            <span v-else class="btn-off bron-off">{{flatsPage.flats_cards_info.flat_btn_book_name}}</span>
                            <a 
                                :href="'https://lk01.bazis.kz/?apartment_id=' + modalData.id + '&method=by'" class="by" target="_blank" 
                                v-if="modalData.hasJointVentureAgreement"
                                >{{flatsPage.flats_cards_info.flat_btn_by_name}}
                            </a>
                            <span v-else class="btn-off by-off">{{flatsPage.flats_cards_info.flat_btn_by_name}}</span>
                        </div>
                        <div v-else>
                             <a 
                                :href="'https://lk01.bazis.kz/?apartment_id=' + modalData.id + '&method=book'" class="bron" target="_blank" 
                                v-if="checkConfirmPurchase('book', modalData.complexCode, modalData.blockName)"
                                >{{flatsPage.flats_cards_info.flat_btn_book_name}}
                            </a>
                            <span v-else class="btn-off bron-off">{{flatsPage.flats_cards_info.flat_btn_book_name}}</span>
                            <a 
                                :href="'https://lk01.bazis.kz/?apartment_id=' + modalData.id + '&method=by'" class="by" target="_blank" 
                                v-if="checkConfirmPurchase('by', modalData.complexCode, modalData.blockName)"
                                >{{flatsPage.flats_cards_info.flat_btn_by_name}}
                            </a>
                            <span v-else class="btn-off by-off">{{flatsPage.flats_cards_info.flat_btn_by_name}}</span>
                        </div>
                    </div>
                </div>
                <div class="flat-card-form">
                    <div class="flat-card-form-titles">
                        <h3>{{form.form_sales_land_flat_title}}</h3>
                        <p>{{form.form_sales_land_flat_desc}}</p>
                    </div>
                    <formFields class="form-flats-card-setup"></formFields>
                </div>
                <div class="privacy-desc-mobile" v-if="form != null">
                    <p>
                        <span>{{ salesCard.shablon_form_privacy_desc.one }}</span> 
                        «<span>{{ form.form_sales_promo_btn }}</span>» <br>
                        <span class="two">{{ salesCard.shablon_form_privacy_desc.two }}</span>
                        <span><a href="https://sales.bazis.kz/privacy-policy" target="_blank">{{ salesCard.shablon_form_privacy_desc.word }}</a></span>
                        <span class="three">{{ salesCard.shablon_form_privacy_desc.three }}</span>
                    </p>
                </div>
            </div>
        </div>
    </modal>
    <!-- end -->
</template>

<script>
    import {mapGetters} from 'vuex'
    import formFields from '@/components/forms/form-flat.vue';
	import formMail from '@/components/forms/form-mail.vue';	
    export default {
        name: 'sale-CRM-flats-modal',
        props: ['mobileView'],
        components: {
            formFields,
            formMail,
        },
        data () {
            return {
                modalWidth: 1000,
				modalHeight: 670,
				// modalScroll: false,
				transitionName: 'pop-out',
                dataLang: '',
                formActive: false,
                resizeCardImg: false,
                project: window.host,
                projectHost: window.host,
                pdf: null,
            }
        },
        computed: mapGetters({
            flatsPage: 'loadSalesFlatsPageData',
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            saleItem: 'loadSaleCardItem',
            saleFilterParams: 'loadSalesFilterCardParams',
            currentCity: 'loadCurCity',
            form: 'loadForms',
            flats: 'loadSalesCardPage',
            modalData: 'loadSalesLandModalDataArr',
            banerTopCoockieVisible: 'loadCockieBanerTopVisible',
        }),
        methods: {
            getNumbersOfBlock(str) { 
                var parseStr = str.split(',')[0];
                return parseStr.replace(/[^0-9]+/g, "");
            },
            getNumbersOfString(str) {
                return str.replace(/[^0-9]+/g, "");
            },
            getNumbersOfBlockDiscovery(str) { 
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockSoho(str) {
                var parseStr = str.split(',')[0];
                return parseStr.replace('Квартал', '').replace(/ /g, '');
            },
            getBlockPartSOH(str) {
                var blockPart;
                blockPart = str.split(',')[1];
                blockPart = blockPart.replace('Блок', '');
                blockPart = blockPart.replace(/ /g, '');
                return blockPart;
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            },
            getFullPrice(price, area) {
                const result = price * area;
                return this.getNumber(parseInt(result));
            },
            getIdPDF(arr) {
                var filItem = arr.filter(item => {
                    return item.typeCode == '5'
                });
                if (filItem.length) {
                    this.pdf = filItem[0].id;
                } else {
                    this.pdf = null;
                }
                // console.log(this.pdf);
            },
            FlatCardModalClosed() {
				this.formActive = false;
				window.body.removeClass('overflowTrue');
				// document.getElementById('secret-btns').classList.remove('hideAll');
                document.getElementById('header').classList.remove('notvisibleSalesLand');
                document.getElementById('landNav').classList.remove('notvisibleSalesLand');
                document.getElementById('footer').classList.remove('notvisibleSalesLand');
                if (this.banerTopCoockieVisible == true) {
                    document.getElementById('banerTopHorizont').classList.remove('notvisibleSalesLand');
                }
			},
			FlatCardModalOpened() {
				window.Sharer.init();
				window.body.addClass('overflowTrue');
				// document.getElementById('secret-btns').classList.add('hideAll');
				document.getElementById('header').classList.add('notvisibleSalesLand');
                document.getElementById('landNav').classList.add('notvisibleSalesLand');
                document.getElementById('footer').classList.add('notvisibleSalesLand');
                if (this.banerTopCoockieVisible == true) {
                    document.getElementById('banerTopHorizont').classList.add('notvisibleSalesLand');
                }
			},
            closeFlatModal() {
				this.$modal.hide('sales_land_flat_card_crm_modal');
            },
            InputMailInit() {
				this.formActive = true;
            },
            resizeModalCardImg() {
				this.resizeCardImg = !this.resizeCardImg;
            },
            CapitalizeID(s) {
                if (typeof s !== 'string') return ''
                return s.charAt(0).toUpperCase() + s.slice(1)
            },
            changeLang () {
                this.dataLang = window.body.data('language');
                if (this.dataLang == '') {
                    this.dataLang = 'ru'
                }
                // console.log(this.dataLang)
            },
            checkConfirmPurchase(param, code, blockName) {
                // console.log(param, code, blockName)
                var blockNameBparse = blockName;
                if (code != 'SOH') {
                    blockName = this.getNumbersOfString(blockName);
                } else if (code == 'SOH') {
                    blockName = this.getNumbersOfBlockSoho(blockName);
                } 
                // console.log(blockName, blockNameBparse)

                if (param == 'book') {
                    if (code == 'AKV') { // Настройка кнопок Акварель
                        if (blockName == '25' || blockName == '26' || blockName == '27' || blockName == '28') {
                            return true;
                        } else {
                            return false;
                        }
                    } 
                    // ASTANA
                    else if (code == 'SOH') { // Настройка кнопок Soho
                        // console.log(blockName, this.blockPart)
                        if (blockName == '2A') {
                            if (this.getBlockPartSOH(blockNameBparse) == 'А1' || this.getBlockPartSOH(blockNameBparse) == 'А2' || this.getBlockPartSOH(blockNameBparse) == 'А3' || this.getBlockPartSOH(blockNameBparse) == 'А4' || this.getBlockPartSOH(blockNameBparse) == 'А5' || this.getBlockPartSOH(blockNameBparse) == 'А6' || this.getBlockPartSOH(blockNameBparse) == 'А7' || this.getBlockPartSOH(blockNameBparse) == 'А8' || this.getBlockPartSOH(blockNameBparse) == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (blockName == '2А') {
                            if (this.getBlockPartSOH(blockNameBparse) == 'А1' || this.getBlockPartSOH(blockNameBparse) == 'А2' || this.getBlockPartSOH(blockNameBparse) == 'А3' || this.getBlockPartSOH(blockNameBparse) == 'А4' || this.getBlockPartSOH(blockNameBparse) == 'А5' || this.getBlockPartSOH(blockNameBparse) == 'А6' || this.getBlockPartSOH(blockNameBparse) == 'А7' || this.getBlockPartSOH(blockNameBparse) == 'А8' || this.getBlockPartSOH(blockNameBparse) == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                } else if (param == 'by') {
                    // ALMATY
                    if (code == 'AKV') { // Настройка кнопок Акварель
                        if (blockName == '25' || blockName == '26' || blockName == '27' || blockName == '28') {
                            return true;
                        } else {
                            return false;
                        }
                    } 
                    // ASTANA
                    else if (code == 'SOH') { // Настройка кнопок Soho
                        if (blockName == '2A') {
                            if (this.getBlockPartSOH(blockNameBparse) == 'А1' || this.getBlockPartSOH(blockNameBparse) == 'А2' || this.getBlockPartSOH(blockNameBparse) == 'А3' || this.getBlockPartSOH(blockNameBparse) == 'А4' || this.getBlockPartSOH(blockNameBparse) == 'А5' || this.getBlockPartSOH(blockNameBparse) == 'А6' || this.getBlockPartSOH(blockNameBparse) == 'А7' || this.getBlockPartSOH(blockNameBparse) == 'А8' || this.getBlockPartSOH(blockNameBparse) == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (blockName == '2А') {
                            if (this.getBlockPartSOH(blockNameBparse) == 'А1' || this.getBlockPartSOH(blockNameBparse) == 'А2' || this.getBlockPartSOH(blockNameBparse) == 'А3' || this.getBlockPartSOH(blockNameBparse) == 'А4' || this.getBlockPartSOH(blockNameBparse) == 'А5' || this.getBlockPartSOH(blockNameBparse) == 'А6' || this.getBlockPartSOH(blockNameBparse) == 'А7' || this.getBlockPartSOH(blockNameBparse) == 'А8' || this.getBlockPartSOH(blockNameBparse) == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    } 
                } else {
                    return false;
                }
            },
            // setGridView(param) { 
			// 	this.$store.commit('gridView', param);
            // },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.changeLang();
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-modal.scss';
    @import '@/styles/components/forms/form-flat.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-modal-respond.scss';
</style>